import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
import { useResourceGroups } from "../hooks/useResourceGroups";

const GroupsContext = createContext(undefined);

export const ResourceGroupsProvider = ({ children }) => {
  const { groups, loading, error } = useResourceGroups();

  return (
    <GroupsContext.Provider value={{ groups, loading, error }}>
      {children}
    </GroupsContext.Provider>
  );
};

ResourceGroupsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useGroups = () => {
  const context = useContext(GroupsContext);
  if (context === undefined) {
    throw new Error("useGroups must be used within a ResourceGroupsProvider");
  }
  return context;
};
